import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx'
import Typography from '../UniformComponents/Typography'
import Input from './form/Input'

@observer
class Search extends Component {
    @observable searchStr = ''

    @observable showClear = false

    constructor(props) {
        super(props)
        makeObservable(this)
    }

    componentDidMount() {
        const { autoFocus } = this.props

        if (autoFocus) {
            this.searchRef.focus()
        }
    }

    // onClick = () => {}

    clear = () => {
        const { onSearch } = this.props
        this.searchStr = ''
        this.showClear = false
        onSearch()
    }

    // search = () => {}

    changeSearch = ({ value }) => {
        const { onChange, onSearch, searchOnBlur } = this.props

        this.searchStr = value
        this.showClear = this.searchStr !== ''

        if (typeof onChange === 'function') {
            onChange()
        }
        if (!searchOnBlur) {
            onSearch()
        }
    }

    onKeyDown = (e) => {
        const { onSearch } = this.props
        if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            if (onSearch) {
                onSearch()
            }
        }
    }

    render() {
        const { oid, onSearch, cssClass, label } = this.props
        const className = `search  ${cssClass} ${oid < 6 ? 'pull-right' : ''}`
        const style = oid === 7 ? { width: '100%' } : {}
        return (
            <div className={className} style={style}>
                <Typography
                    type="b"
                    style={{
                        backgroundColor: 'white',
                        position: 'absolute',
                        padding: '0px 8px',
                        margin: '-38px 14px 0px',
                        lineHeight: '14px',
                        fontWeight: 700,
                        zIndex: 1,
                    }}
                >
                    {label}
                </Typography>
                <Input
                    className="search-box"
                    type="text"
                    inputRef={(r) => { this.searchRef = r }}
                    value={this.searchStr}
                    onChange={this.changeSearch}
                    onBlur={onSearch}
                    onKeyDown={this.onKeyDown}
                    style={{
                        marginTop: 14,
                    }}
                />
                {!this.showClear
                    ? (
                        <i className="search-icon fa-regular fa-search" />
                    ) : (
                        <i
                            className="close-icon fa-regular fa-x"
                            onClick={this.clear}
                        />
                    )}
            </div>
        )
    }
}

export default Search
